import axios from '@/lib/axios';
import ChangeMailParams from '../types/ChangeMailParams';

const changeMail = (facilityCode: string, data: ChangeMailParams) => {
  return axios.patch(`/facility/change_mail/${facilityCode}`, data);
}

export default changeMail;